import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('BrandDA', BrandDA);

    BrandDA.$inject = [
        'Restangular',
        'CONF',
        '$http',
    ];

    /**
     * Class permettant la manipulation des infos realtives au donneur d'ordre
     */

    /* @ngInject */
    function BrandDA(
        Restangular,
        CONF,
        $http
    ) {
        var baseUrl = CONF.apiBaseUrl + '/v1/brand';
        var httpBrandUrl = CONF.apiContext + CONF.apiBaseUrl + '/v1/brand/';

        var exports = {
            saveBrand: saveBrand,
            saveFile: saveFile
        };

        return exports;

        ////////////////

        /**
         * Création et Modification de la personalisation (Brand).
         */
        function saveBrand(brand) {
            return Restangular.all(baseUrl).customPOST(brand);
        }

        /**
         * Sauvegarder le fichier temporaire.
         */
        function saveFile(file) {
            const formData = new FormData();
            formData.append('file', file);
            var promise = $http({
                method: 'POST',
                url: httpBrandUrl + 'file/stage',
                headers: { 'Content-Type': undefined },
                data: formData,
                transformRequest: function (data) {
                    return data;
                },
            }).then(function(response) {
                return response.data;
            });
            return promise;
        }
    }
})();
